import React, { useEffect, useState } from 'react';
import { useDraggable } from '@dnd-kit/core';
import { motion } from 'framer-motion';
import { useStyles } from '@archipro-design/aria';
import { IconPlus } from '@archipro-design/icons';
import * as S from './DraggablePreview.style';
import type { Coordinates, RGB } from '../../type';

interface DraggablePreviewProps {
    coordinates: Coordinates;
    color: RGB | null;
}

export const DraggablePreview = ({
    coordinates,
    color,
}: DraggablePreviewProps) => {
    const [position, setPosition] = useState(coordinates);
    const { setNodeRef, attributes, listeners, transform } = useDraggable({
        id: 'draggable-preview',
    });

    const show = coordinates.x > 0 || coordinates.y > 0;

    useEffect(() => {
        if (transform) {
            setPosition({
                x: coordinates.x + transform.x,
                y: coordinates.y + transform.y,
            });
        }
    }, [coordinates, transform]);

    useEffect(() => {
        setPosition(coordinates);
    }, [coordinates]);

    const positionStyles = {
        show,
        cursorCoordinates: position,
        currentColor: color,
    };

    const { css } = useStyles({ ...positionStyles });

    return (
        <motion.div
            animate={{ opacity: show ? 1 : 0 }}
            className={css(S.PickerCursor)}
            ref={setNodeRef}
            {...attributes}
            {...listeners}
        >
            <IconPlus className={css(S.PickerCursorIcon)} />
        </motion.div>
    );
};
